import { render } from "./TelAreaSelect.vue?vue&type=template&id=47ddf2b1&scoped=true"
import script from "./TelAreaSelect.vue?vue&type=script&lang=js"
export * from "./TelAreaSelect.vue?vue&type=script&lang=js"

import "./TelAreaSelect.vue?vue&type=style&index=0&id=47ddf2b1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47ddf2b1"]])

export default __exports__